// extracted by mini-css-extract-plugin
module.exports = {"EventCard":"EventCard_EventCard__ftmZ0"};